import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

const initialState = Immutable({
  updatingSocialLinks: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_SOCIAL_LINKS.START: {
      return state.set('updatingSocialLinks', true);
    }

    case actionTypes.UPDATE_SOCIAL_LINKS.FAILURE: {
      return state.set('updatingSocialLinks', false);
    }

    case actionTypes.UPDATE_SOCIAL_LINKS.SUCCESS: {
      return state.set('updatingSocialLinks', false);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateSocialLinks/reducer.js